import { useRouter } from 'next/router';
import { useBrowserLayoutEffect } from './useBrowserLayoutEffect';

export const useRouterState = () => {
  const router = useRouter();

  useBrowserLayoutEffect(() => {
    window.routerState = window.routerState || 'idle';
  }, []);

  useBrowserLayoutEffect(() => {
    const handleStart = () => {
      window.routerState = 'changing';
    };
    const handleStop = () => {
      window.routerState = 'ready';
    };

    const handleError = () => {
      window.routerState = 'failed';
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleError);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleError);
    };
  }, [router]);
};
